var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrevLabel = function SvgPrevLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.113,
    height: 12.181
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M0 6.091a1 1 0 0 1 .294-.709L5.407.291A1 1 0 1 1 6.82 1.709l-4.4 4.382 4.4 4.382a1 1 0 1 1-1.411 1.417L.297 6.8A1 1 0 0 1 0 6.091Z",
    fill: "currentColor"
  })));
};
export default SvgPrevLabel;